module.exports = __webpack_public_path__ + "img/5.ca46b484.jpg";